// extracted by mini-css-extract-plugin
module.exports = {"icon":"_2n-DhfsgPrMBzylY756u9b"};